"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupReplayAudio = setupReplayAudio;
const audioHandler_1 = require("./audioHandler");
async function setupReplayAudio(pageStateHandler) {
    audioHandler_1.PageAudioHandler.replayPresses = 0; // reset to zero at beginning of trial
    if (pageStateHandler.replayBtn) {
        if (pageStateHandler.playStimulusOnLoad) {
            pageStateHandler.disableReplayBtn();
            const enableDelayBuffer = 100; //in ms
            const totalStimulusDurationMs = await pageStateHandler.getStimulusDurationMs(); //in ms
            const totalDelay = totalStimulusDurationMs + enableDelayBuffer;
            setTimeout(() => {
                pageStateHandler.enableReplayBtn();
            }, totalDelay);
        }
        const audioConfig = {
            restrictRepetition: {
                enabled: false,
                maxRepetitions: 2,
            },
            onEnded: () => {
                pageStateHandler.enableReplayBtn();
            },
        };
        async function replayAudio() {
            audioHandler_1.PageAudioHandler.replayPresses++;
            pageStateHandler.disableReplayBtn();
            if (typeof pageStateHandler.audioUri === 'string') {
                audioHandler_1.PageAudioHandler.playAudio(pageStateHandler.audioUri, audioConfig);
            }
            else {
                // multiple audio files
                for (let i = 0; i < pageStateHandler.audioUri.length; i++) {
                    const audioUri = pageStateHandler.audioUri[i];
                    const isLastAudio = i === pageStateHandler.audioUri.length - 1;
                    await new Promise((resolve) => {
                        const configWithCallback = {
                            ...audioConfig,
                            onEnded: () => {
                                var _a;
                                if (isLastAudio) {
                                    // replay button only enabled after the last audio has played
                                    (_a = audioConfig.onEnded) === null || _a === void 0 ? void 0 : _a.call(audioConfig);
                                }
                                resolve();
                            },
                        };
                        audioHandler_1.PageAudioHandler.playAudio(audioUri, configWithCallback);
                    });
                }
            }
        }
        pageStateHandler.replayBtn.addEventListener('click', replayAudio);
    }
}
